import { render, staticRenderFns } from "./ServicesDialog.vue?vue&type=template&id=2745f14a"
import script from "./ServicesDialog.vue?vue&type=script&lang=js"
export * from "./ServicesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports